module.exports = __webpack_public_path__ + "static/media/frequency.6ec4ebd5.jpg";